<template>
  <el-container class="layout-container">
    <el-aside width="200px">
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical"
        :collapse="isCollapse"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
      >
        <el-menu-item index="/dashboard" @click="handleMenuClick('/admin')">
          <el-icon><House /></el-icon>
          <span>管理后台</span>
        </el-menu-item>
        
        <el-sub-menu index="/wechat">
          <template #title>
            <el-icon><ChatDotRound /></el-icon>
            <span>微信管理</span>
          </template>
          <el-menu-item index="/wechat/config" @click="handleMenuClick('/wechat/config')">微信配置</el-menu-item>
          <el-menu-item index="/wechat/menu" @click="handleMenuClick('/wechat/menu')">菜单管理</el-menu-item>
          <el-menu-item index="/wechat/followers" @click="handleMenuClick('/wechat/followers')">关注者管理</el-menu-item>
          <el-menu-item index="/wechat/history" @click="handleMenuClick('/wechat/history')">消息历史</el-menu-item>
          <el-menu-item index="/wechat/statistics" @click="handleMenuClick('/wechat/statistics')">消息统计</el-menu-item>
          <el-menu-item index="/wechat/message" @click="handleMenuClick('/wechat/message')">消息管理</el-menu-item>
          <el-menu-item index="/wechat/chat" @click="handleMenuClick('/wechat/chat')">聊天管理</el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="/ai">
          <template #title>
            <el-icon><Monitor /></el-icon>
            <span>AI管理</span>
          </template>
          <el-menu-item index="/ai-admin/sessions" @click="handleMenuClick('/ai-admin/sessions')">会话管理</el-menu-item>
          <el-menu-item index="/ai-admin/statistics" @click="handleMenuClick('/ai-admin/statistics')">统计分析</el-menu-item>
          <el-menu-item index="/ai-admin/hot-topics" @click="handleMenuClick('/ai-admin/hot-topics')">热门话题</el-menu-item>
          <el-menu-item index="/ai-admin/user-usage" @click="handleMenuClick('/ai-admin/user-usage')">用户使用统计</el-menu-item>
        </el-sub-menu>

        <el-menu-item index="/knowledge" @click="handleMenuClick('/knowledge')">
          <el-icon><collection /></el-icon>
          <span>知识库管理</span>
        </el-menu-item>

        <el-sub-menu index="/system">
          <template #title>
            <el-icon><Setting /></el-icon>
            <span>系统管理</span>
          </template>
          <el-menu-item index="/system/users" @click="handleMenuClick('/system/users')">用户管理</el-menu-item>
          <el-menu-item index="/system/roles" @click="handleMenuClick('/system/roles')">角色管理</el-menu-item>
          <el-menu-item index="/system/permissions" @click="handleMenuClick('/system/permissions')">权限管理</el-menu-item>
          <el-menu-item index="/system/userGroups" @click="handleMenuClick('/system/userGroups')">用户组管理</el-menu-item>
          <el-menu-item index="/system/permission-templates" @click="handleMenuClick('/system/permission-templates')">权限模板</el-menu-item>
          <el-menu-item index="/system/user-type-change-logs" @click="handleMenuClick('/system/user-type-change-logs')">用户类型变更日志</el-menu-item>
        </el-sub-menu>
      </el-menu>
    </el-aside>
    
    <el-container>
      <el-header>
        <div class="header-left">
          <el-icon class="toggle-sidebar" @click="toggleSidebar">
            <Fold v-if="!isCollapse" />
            <Expand v-else />
          </el-icon>
          <el-button type="primary" size="small" @click="testConsole" style="margin-left: 10px;">
            测试控制台
          </el-button>
        </div>
        <div class="header-right">
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="el-dropdown-link">
              <el-avatar :size="32" :src="userInfo.avatar">
                {{ userInfo.nickname?.substring(0, 1) || userInfo.username?.substring(0, 1) || 'U' }}
              </el-avatar>
              <span class="username">{{ userInfo.nickname || userInfo.username || '未登录' }}</span>
              <el-icon class="el-icon--right"><arrow-down /></el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="profile">
                  <el-icon><User /></el-icon>个人资料
                </el-dropdown-item>
                <el-dropdown-item v-if="false" command="admin">
                  <el-icon><Setting /></el-icon>管理后台
                </el-dropdown-item>
                <el-dropdown-item divided command="logout">
                  <el-icon><SwitchButton /></el-icon>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-header>
      
      <el-main>
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { defineComponent, ref, computed, watch, version, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { House, ChatDotRound, Monitor, Fold, Expand, ArrowDown, Setting, User, SwitchButton, collection } from '@element-plus/icons-vue'
import ElementPlus from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useUserStore } from '@/stores/user'

export default defineComponent({
  name: 'MainLayout',
  components: {
    House,
    ChatDotRound,
    Monitor,
    Fold,
    Expand,
    ArrowDown,
    Setting,
    User,
    SwitchButton,
    collection
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const userStore = useUserStore()
    const isCollapse = ref(false)
    const userInfo = computed(() => userStore.userInfo || {})

    const activeMenu = computed(() => {
      console.log('当前路由路径:', route.path)
      return route.path
    })

    // 监听路由变化
    watch(() => route.path, (newPath, oldPath) => {
      console.log('路由变化:', {
        from: oldPath,
        to: newPath,
        fullRoute: route
      })
    }, { immediate: true })

    // 使用Pinia Store查询用户信息
    const fetchUserInfo = async () => {
      console.log('获取用户信息，当前store状态:', {
        hasToken: !!userStore.token,
        hasUserInfo: !!userStore.userInfo,
        isLoggedIn: userStore.isLoggedIn
      })
      
      try {
        // 如果已经有用户信息，直接使用
        if (userStore.userInfo) {
          console.log('已有用户信息:', userStore.userInfo)
          return
        }
        
        // 否则尝试从API获取
        if (userStore.token) {
          await userStore.getUserInfo()
          console.log('获取用户信息成功:', userStore.userInfo)
        } else {
          throw new Error('没有token')
        }
      } catch (error) {
        console.error('获取用户信息错误:', error)
        // 如果获取用户信息失败，跳转到登录页
        userStore.clearUserState()
        router.push('/login')
      }
    }

    // 处理下拉菜单命令
    const handleCommand = (command) => {
      switch (command) {
        case 'profile':
          router.push('/profile')
          break
        case 'admin':
          router.push('/admin')
          break
        case 'logout':
          ElMessageBox.confirm('确定要退出登录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            try {
              await userStore.logout()
              ElMessage.success('退出登录成功')
              router.push('/login')
            } catch (error) {
              console.error('退出登录错误:', error)
              // 即使请求失败，也清除本地状态并跳转
              userStore.clearUserState()
              router.push('/login')
            }
          }).catch(() => {
            // 取消退出
          })
          break
      }
    }

    const handleMenuClick = (path) => {
      console.log('菜单点击:', path)
      router.push(path).catch(err => {
        console.error('路由跳转错误:', err)
      })
    }

    const toggleSidebar = () => {
      isCollapse.value = !isCollapse.value
    }

    // 添加测试函数
    const testConsole = () => {
      console.log('=== 测试控制台输出 ===')
      console.log('1. 基础信息:')
      console.log('- 当前时间:', new Date().toLocaleString())
      console.log('- 浏览器信息:', navigator.userAgent)
      
      console.log('\n2. 路由信息:')
      console.log('- 当前路径:', route.path)
      console.log('- 路由名称:', route.name)
      console.log('- 路由参数:', route.params)
      console.log('- 查询参数:', route.query)
      
      console.log('\n3. 组件信息:')
      console.log('- Element Plus版本:', ElementPlus.version)
      console.log('- Vue版本:', version)
      
      console.log('\n4. 系统状态:')
      console.log('- 侧边栏状态:', isCollapse.value ? '折叠' : '展开')
      console.log('- 当前激活菜单:', activeMenu.value)
      console.log('- 用户信息:', userInfo.value)
      
      console.log('\n5. 认证信息:')
      console.log('- token存在:', !!userStore.token)
      console.log('- token长度:', userStore.token?.length || 0)
      console.log('- 登录状态:', userStore.isLoggedIn)
      
      console.log('\n6. 环境信息:')
      console.log('- 运行环境:', process.env.NODE_ENV)
      console.log('- API地址:', process.env.VUE_APP_BASE_API || '')
      
      console.log('=== 测试完成 ===')
    }

    // 初始化时获取用户信息
    onMounted(async () => {
      console.log('Layout组件加载，检查token并获取用户信息')
      console.log('当前store状态:', {
        hasToken: !!userStore.token,
        hasUserInfo: !!userStore.userInfo,
        isLoggedIn: userStore.isLoggedIn
      })
      
      // 检查认证状态
      if (userStore.token) {
        console.log('有token，获取用户信息')
        await fetchUserInfo()
      } else {
        console.warn('未找到token，跳转到登录页')
        router.push('/login')
      }
    })

    return {
      isCollapse,
      activeMenu,
      userInfo,
      toggleSidebar,
      handleMenuClick,
      handleCommand,
      testConsole
    }
  }
})
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.el-aside {
  background-color: #304156;
  transition: width 0.3s;
}

.el-menu-vertical {
  height: 100%;
  border-right: none;
}

.el-header {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
}

.header-left {
  display: flex;
  align-items: center;
}

.toggle-sidebar {
  font-size: 20px;
  cursor: pointer;
  padding: 0 15px;
}

.header-right {
  padding-right: 20px;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 10px;
}

.username {
  margin: 0 8px;
  font-size: 14px;
}

.el-dropdown-menu .el-icon {
  margin-right: 8px;
}

.el-main {
  background-color: #f0f2f5;
  padding: 20px;
}
</style> 